import React from 'react';
import PropTypes from 'prop-types';
import {filter, map} from 'lodash';
import ConnectionInformationCard from './connection-information-card';

const propTypes = {
  educatorConnections: PropTypes.arrayOf(
    PropTypes.shape({
      _id: PropTypes.string.isRequired,
      connection: PropTypes.number.isRequired,
      createdAt: PropTypes.string.isRequired,
      educator: PropTypes.shape({
        displayNameToStudent: PropTypes.string.isRequired,
      }).isRequired,
    })
  ).isRequired,
  userConnections: PropTypes.arrayOf(
    PropTypes.shape({
      status: PropTypes.string.isRequired,
      createdAt: PropTypes.string.isRequired,
      connectedUser: PropTypes.shape({
        firstName: PropTypes.string.isRequired,
        lastName: PropTypes.string.isRequired,
      }).isRequired,
      _id: PropTypes.string.isRequired,
    })
  ).isRequired,
  acceptEducatorConnection: PropTypes.func.isRequired,
  rejectEducatorConnection: PropTypes.func.isRequired,
  acceptConnection: PropTypes.func.isRequired,
  rejectConnection: PropTypes.func.isRequired,
  removeConnection: PropTypes.func.isRequired,
};

const educatorStatus = (connection) => {
  if (connection === 1) return 'accepted';
  if (connection === -1) return 'rejected';
  return 'pending';
};

const ConnectionsList = ({
  educatorConnections,
  userConnections,
  acceptEducatorConnection,
  rejectEducatorConnection,
  acceptConnection,
  rejectConnection,
  removeConnection,
}) => {
  const activeUserConnections = filter(userConnections, ({status}) => status !== 'rejected');
  const activeEducatorConnections = filter(
    educatorConnections,
    ({connection}) => connection !== -1
  );

  return (
    <div className="connections-list row" data-testid="active-connections-list">
      {map(activeUserConnections, ({status, connectedUser: {firstName, lastName, image}, _id}) => (
        <ConnectionInformationCard
          id={_id}
          status={status}
          firstName={firstName}
          lastName={lastName}
          image={image}
          displayName={`${firstName} ${lastName}`}
          key={_id}
          acceptConnection={acceptConnection}
          rejectConnection={rejectConnection}
          removeConnection={removeConnection}
          type="Parent"
        />
      ))}
      {map(
        activeEducatorConnections,
        ({_id, connection, educator: {displayNameToStudent, firstName, lastName}}) => (
          <ConnectionInformationCard
            id={_id}
            status={educatorStatus(connection)}
            firstName={firstName}
            lastName={lastName}
            displayName={displayNameToStudent}
            key={_id}
            acceptConnection={acceptEducatorConnection}
            rejectConnection={rejectEducatorConnection}
            removeConnection={rejectEducatorConnection}
            type="Educator"
          />
        )
      )}
    </div>
  );
};

ConnectionsList.propTypes = propTypes;

export default ConnectionsList;
